/* eslint-disable use-isnan */
import React from 'react'
import { scaleTime, scaleLinear } from 'd3-scale'
import { line, curveLinear } from 'd3-shape'
import { extent } from 'd3-array'
import { axisBottom, axisLeft } from 'd3-axis'
import { svgHeight, svgWidth, findMax } from '../utils'
import styled from 'styled-components'
import { getDetailData, getMetricDisplayMap } from '../selectors'
import { fromNullable } from 'data.maybe'

import AxisRenderer from './AxisRenderer'

import { connect } from 'react-redux'
import R from 'ramda'

const DetailedLineChart = ({
  data,
  unitId,
  valType,
  valueKeys,
  unitMap,
  contentWidth,
  contentHeight,
  margin,
  colorScale,
  maxValue,
  displayMap,
}) => {
  const lengdSpace = 0
  const width = svgWidth(contentWidth, margin) - lengdSpace
  const height = svgHeight(contentHeight, margin) - 100
  const filteredData = data.filter(d => d.unitId === unitId)

  const x = scaleTime()
    .range([0, width])
    .domain(extent(filteredData, d => d.date))

  const y = scaleLinear()
    .range([height, 0])
    .domain([0, findMax(maxValue, valueKeys, filteredData)])

  const lineBaseRenderer = line()
    .curve(curveLinear)
    .x(d => x(d.date))

  const lines = valueKeys.map(k => {
    const Line = styled.path`
      stroke: ${colorScale(k)};
      fill: none;
      stroke-width: ${k === valType ? 5 : 2}px;
      stroke-linecap: round;
      stroke-linejoin: round;
    `
    const lineRenderer = lineBaseRenderer
      .y(d => y(d[k]))

      .defined(d => !R.isNil(d[k]) && y(d[k]) !== NaN && x(d.date) !== NaN)

    return <Line key={k} d={lineRenderer(filteredData)} />
  })

  const UnitDisplay = styled.tspan`
    font-size: 2.5em;
    font-weight: bold;
    text-anchor: middle;
    fill: #3c3c3c;
  `
  const ValTypeDisplay = styled.tspan`
    font-size: 1.2em;
    font-weight: bold;
    text-anchor: middle;
    fill: #3c3c3c;
  `

  const xAxis = axisBottom(x)
  const yAxis = axisLeft(y).ticks(null, 's')

  const Dot = styled.circle`
    fill: white;
    stroke: brown;
    stroke-width: 6;
  `

  return (
    <svg width={contentWidth} height={contentHeight}>
      <g transform={`translate(${margin.left + lengdSpace},${margin.top + 100})`}>
        <AxisRenderer axis={yAxis} />
        <AxisRenderer dy={height} axis={xAxis} />
        {lines}
        <g transform={`translate(${width / 2},-50)`}>
          <text x="0" y="0">
            <UnitDisplay x="0">{unitMap[unitId] || unitId}</UnitDisplay>
            <ValTypeDisplay x="0" dy="1.2em">
              {fromNullable(displayMap)
                .map(m => m[valType])
                .getOrElse(valType)}
            </ValTypeDisplay>
          </text>
        </g>
        {
          // valueKeys.map(k => ({ k,val: filteredData[0][k] }))
          // .map(({ k,val }) => (
          //   <Indicator key={`${k}!id`} x="-30" y ={y(val)}> {k} </Indicator>
          // ))
        }
        {filteredData
          .filter(d => !R.isNil(d[valType]))
          .map(d => (
            <Dot key={`${d.date} valType`} cx={x(d.date)} cy={y(d[valType])} r="10">
              <title>{`${valType} : ${d[valType]}`}</title>
            </Dot>
          ))}
      </g>
    </svg>
  )
}
const mapStateToProps = state => ({
  data: getDetailData(state),
  displayMap: getMetricDisplayMap(state),
})

export default connect(mapStateToProps)(DetailedLineChart)
